import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEye, FiEdit } = FiIcons;

const MarkdownEditor = ({ value = '', onChange }) => {
  const [mode, setMode] = useState('edit');

  const renderPreview = (markdown) => {
    // Simple markdown rendering
    const lines = markdown.split('\n');
    const elements = [];
    
    lines.forEach((line, index) => {
      line = line.trim();
      
      if (line.startsWith('# ')) {
        elements.push(
          <h1 key={index} className="text-2xl font-bold text-gray-900 mb-3">
            {line.substring(2)}
          </h1>
        );
      } else if (line.startsWith('## ')) {
        elements.push(
          <h2 key={index} className="text-xl font-bold text-gray-900 mb-2">
            {line.substring(3)}
          </h2>
        );
      } else if (line.startsWith('### ')) {
        elements.push(
          <h3 key={index} className="text-lg font-bold text-gray-900 mb-2">
            {line.substring(4)}
          </h3>
        );
      } else if (line.startsWith('- ') || line.startsWith('* ')) {
        elements.push(
          <li key={index} className="text-gray-700 mb-1 ml-4">
            • {line.substring(2)}
          </li>
        );
      } else if (line.length > 0) {
        // Handle links
        const withLinks = line.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" class="text-nutrition-600 hover:text-nutrition-700 underline" target="_blank" rel="noopener noreferrer">$1</a>'
        );
        
        elements.push(
          <p 
            key={index} 
            className="text-gray-700 mb-3 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: withLinks }}
          />
        );
      } else {
        elements.push(<br key={index} />);
      }
    });
    
    return elements;
  };

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden">
      {/* Toolbar */}
      <div className="bg-gray-50 border-b border-gray-200 px-3 py-2 flex items-center justify-between">
        <div className="text-sm text-gray-600">
          Supports: # Headers, - Lists, [Links](url)
        </div>
        <div className="flex space-x-1">
          <button
            type="button"
            onClick={() => setMode('edit')}
            className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
              mode === 'edit'
                ? 'bg-nutrition-100 text-nutrition-700'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <SafeIcon icon={FiEdit} className="w-4 h-4 inline mr-1" />
            Edit
          </button>
          <button
            type="button"
            onClick={() => setMode('preview')}
            className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
              mode === 'preview'
                ? 'bg-nutrition-100 text-nutrition-700'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <SafeIcon icon={FiEye} className="w-4 h-4 inline mr-1" />
            Preview
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="min-h-[300px]">
        {mode === 'edit' ? (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-80 p-4 border-0 resize-none focus:outline-none focus:ring-0"
            placeholder="Write your lesson content here... Use markdown for formatting."
          />
        ) : (
          <div className="p-4 prose max-w-none">
            {value ? (
              <div>{renderPreview(value)}</div>
            ) : (
              <p className="text-gray-500 italic">Nothing to preview yet. Switch to Edit mode to add content.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MarkdownEditor;